const defaultState = {
  name: '',
  position: 0,
};

export default defaultState;
